import { FC, useContext } from "react"
import { SectorsForm } from "./SectorsForm"
import { Breadcrumb } from "antd"
import React from "react"
import { ClusterOutlined } from "@ant-design/icons"
import { NoteContext } from "../NotePage"
import { ReferenceCode, useGetReferenceTyped } from "../../queries/ReferenceQueries"
import Loader from "../../components/Loader/Loader"
import { ProjectContext } from "../ProjectWrapper"
import { useGetProjectSector, useGetStructureSector } from "../../queries/SectorsQueries"
import { Filieres } from "../../client/backend-client/filieres"

export const SectorsFormWrapper: FC = () => {
  const { projectName, baseNotePath } = useContext(NoteContext)
  const { structureId, projectId } = useContext(ProjectContext)
  const { isLoading: areSectorsLoading, data: sectors } = useGetReferenceTyped<Filieres>(
    ReferenceCode.FILIERE
  )

  const { isLoading: isStructureSectorLoading, data: structureSector } =
    useGetStructureSector(structureId)
  const { isLoading: isProjectSectorLoading, data: projectSector } = useGetProjectSector(projectId)

  if (areSectorsLoading || isStructureSectorLoading || isProjectSectorLoading) {
    return <Loader />
  }

  return (
    <>
      <Breadcrumb
        className="breadcrumb"
        items={[
          { title: <ClusterOutlined /> },
          {
            href: `${baseNotePath}/sectors`,
            title: projectName
          },
          { title: "Filières" }
        ]}
      />
      {sectors && (
        <SectorsForm
          sectors={sectors}
          structureSector={structureSector}
          projectSector={projectSector}
        />
      )}
    </>
  )
}
